export default "__VITE_ASSET__C_sSiBzc__"